/* eslint-disable default-case */
import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  IconButton,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import MaterialButton from "../../components/MaterialButton";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  createItem,
  deleteItem,
  fetchAll,
  fetchById,
  updateItem,
} from "../../ApiBaseUrl";
import { useLoading } from "../../context/loading";
import Swal from "sweetalert2";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";

const AddDevice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state;

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const { setCirleLoading } = useLoading();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [branchList, setBranchList] = useState([]);
  const [apiKeyDialog, setApiKeyDialog] = useState({
    open: false,
    apiKey: "",
  });

  const directionOptions = [
    { value: "IN", label: "IN" },
    { value: "OUT", label: "OUT" },
  ];

  const [deviceData, setDeviceData] = useState({
    deviceName: "",
    branch: null,
    direction: null,
    cloudId: "",
    notes: "",
    isActive: true,

    deviceNameStatus: "unchecked",
    branchStatus: "unchecked",
    directionStatus: "unchecked",
    cloudIdStatus: "unchecked",
    notesStatus: "unchecked",
  });

  const [originalData, setOriginalData] = useState({
    deviceName: "",
    branch: null,
    direction: null,
    cloudId: "",
    notes: "",
    isActive: true,
  });

  const fields = [
    "id",
    "deviceName",
    "branch",
    "direction",
    "cloudId",
    "isActive",
    "lastSeen",
    "apiKey",
    "notes",
  ];

  useEffect(() => {
    fetchBranches();
    if (id) {
      fetchDeviceById(id);
      setTogglePage({ view: true, edit: false });
    }
  }, [id]);

  const fetchBranches = async () => {
    try {
      const data = await fetchAll("Branch", ["id", "name"]);
      setBranchList(data?.allBranch || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const fetchDeviceById = async (deviceId) => {
    setCirleLoading(true);
    try {
      const datas = await fetchById("RegisteredDevice", deviceId, fields);
      const data = datas.getRegisteredDeviceById;

      const deviceState = {
        deviceName: data.deviceName,
        branch: { label: data.branch, value: data.branch },
        direction: { label: data.direction, value: data.direction },
        cloudId: data.cloudId || "",
        notes: data.notes || "",
        isActive: data.isActive,

        deviceNameStatus: "success",
        branchStatus: "success",
        directionStatus: "success",
        cloudIdStatus: "unchecked",
        notesStatus: "unchecked",
      };

      setDeviceData(deviceState);
      setOriginalData({
        deviceName: data.deviceName,
        branch: { label: data.branch, value: data.branch },
        direction: { label: data.direction, value: data.direction },
        cloudId: data.cloudId || "",
        notes: data.notes || "",
        isActive: data.isActive,
      });
    } catch (error) {
      console.error("Error fetching device by ID:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDeviceDataChange = (event, selectEvent) => {
    let state = { ...deviceData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "branch" || selectEvent.name === "direction") {
        if (event?.label) {
          state[selectEvent.name + "Status"] = "success";
        } else {
          state[selectEvent.name + "Status"] = "unchecked";
        }
      }
      state[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "deviceName": {
          const regex = new RegExp("^([A-Za-z0-9 \\-_]{1,50})$");
          if (regex.test(event.target.value?.trim())) {
            state[event.target.name + "Status"] = "success";
          } else {
            state[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        }
        case "cloudId": {
          const regex = new RegExp("^.{0,100}$");
          if (regex.test(event.target.value?.trim())) {
            state[event.target.name + "Status"] = "success";
          } else {
            state[event.target.name + "Status"] = "error";
          }
          break;
        }
        case "notes": {
          const regex = new RegExp("^.{0,500}$", "s");
          if (regex.test(event.target.value?.trim())) {
            state[event.target.name + "Status"] = "success";
          } else {
            state[event.target.name + "Status"] = "error";
          }
          break;
        }
      }
      state[event.target.name] = event.target.value;
    }
    setDeviceData(state);
  };

  const handleActiveToggle = (event) => {
    setDeviceData({ ...deviceData, isActive: event.target.checked });
  };

  const checkAllFields = () => {
    return (
      deviceData.deviceNameStatus === "success" &&
      deviceData.branchStatus === "success" &&
      deviceData.directionStatus === "success"
    );
  };

  const handleAddDevice = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit the device details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        submitDevice();
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const handleBackDevice = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your changes?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        discardData();
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const discardData = () => {
    setDeviceData({
      ...deviceData,
      deviceName: originalData.deviceName,
      branch: originalData.branch,
      direction: originalData.direction,
      cloudId: originalData.cloudId,
      notes: originalData.notes,
      isActive: originalData.isActive,
    });
  };

  const submitDevice = async () => {
    setCirleLoading(true);
    const input = {
      deviceName: deviceData.deviceName,
      branch: deviceData.branch ? deviceData.branch.value : "",
      direction: deviceData.direction ? deviceData.direction.value : "",
      cloudId: deviceData.cloudId,
      notes: deviceData.notes,
      isActive: deviceData.isActive,
    };

    try {
      if (togglePage.edit === true) {
        await updateItem("RegisteredDevice", id, input, fields);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Device updated successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/device");
      } else {
        const query = `
          mutation CreateRegisteredDevice($input: RegisteredDeviceInput!) {
            createRegisteredDevice(input: $input) {
              registeredDevice {
                id
                deviceName
                branch
                direction
                cloudId
                isActive
              }
              apiKey
            }
          }
        `;
        const response = await axios.post(
          BASEURL,
          { query, variables: { input } },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        if (response.data?.errors) {
          const errMsg = response.data.errors[0]?.message || "Unknown error";
          Swal.fire({ icon: "error", title: "Failed to save device", text: errMsg });
          return;
        }
        const result = response.data?.data?.createRegisteredDevice;
        if (result?.apiKey) {
          setApiKeyDialog({
            open: true,
            apiKey: result.apiKey,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Device registered successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/device");
        }
      }
    } catch (error) {
      console.error("Error saving device:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Failed to save device",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleRegenerateApiKey = () => {
    setConfirmationDialog({
      open: true,
      title: "Regenerate API Key",
      message:
        "This will invalidate the current API key. The device will stop working until the new key is configured. Continue?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        regenerateKey();
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const regenerateKey = async () => {
    setCirleLoading(true);
    try {
      const query = `
        mutation RegenerateDeviceApiKey($id: ID!) {
          regenerateDeviceApiKey(id: $id) {
            registeredDevice {
              id
              deviceName
            }
            apiKey
          }
        }
      `;
      const response = await axios.post(
        BASEURL,
        { query, variables: { id } },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      const result = response.data?.data?.regenerateDeviceApiKey;
      if (result?.apiKey) {
        setApiKeyDialog({
          open: true,
          apiKey: result.apiKey,
        });
      }
    } catch (error) {
      console.error("Error regenerating API key:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Failed to regenerate API key",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      position: "center",
      icon: "success",
      title: "API Key copied to clipboard!",
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const toggleEdit = () => {
    setTogglePage({ view: false, edit: true });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to delete this device?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        deleteDeviceData(id);
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const deleteDeviceData = async (deviceId) => {
    setCirleLoading(true);
    try {
      const response = await deleteItem("RegisteredDevice", deviceId);
      if (response?.deleteRegisteredDevice?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response?.deleteRegisteredDevice?.message,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/device");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response?.deleteRegisteredDevice?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error deleting device:", error);
      navigate("/device");
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      {/* API Key Dialog */}
      <Dialog
        open={apiKeyDialog.open}
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setApiKeyDialog({ open: false, apiKey: "" });
          navigate("/device");
        }}
      >
        <DialogTitle>Device API Key</DialogTitle>
        <DialogContent>
          <MaterialTypography variant="body2" sx={{ mb: 2 }}>
            Copy this API key and configure it in the Desktop App. This key will
            not be shown in full again.
          </MaterialTypography>
          <MaterialBox
            sx={{
              p: 2,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
              fontFamily: "monospace",
              fontSize: 14,
              wordBreak: "break-all",
              border: "1px solid #ddd",
            }}
          >
            {apiKeyDialog.apiKey}
          </MaterialBox>
        </DialogContent>
        <DialogActions>
          <MaterialButton
            variant="gradient"
            color="dark"
            startIcon={<ContentCopyIcon />}
            onClick={() => copyToClipboard(apiKeyDialog.apiKey)}
          >
            Copy Key
          </MaterialButton>
          <MaterialButton
            variant="outlined"
            color="dark"
            onClick={() => {
              setApiKeyDialog({ open: false, apiKey: "" });
              navigate("/device");
            }}
          >
            Close
          </MaterialButton>
        </DialogActions>
      </Dialog>

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <IconButton
                  onClick={() => navigate("/device")}
                  sx={{ mr: 1, mt: -0.7 }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage.edit
                    ? "Update Device Details"
                    : togglePage.view
                    ? "View Device Details"
                    : "Add Device"}
                </MaterialTypography>
              </Stack>
              {id && togglePage.view === true && (
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={handleRegenerateApiKey}
                    startIcon={<RefreshIcon />}
                  >
                    Regenerate Key
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={AddDelete}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              {/* Device Name */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Device Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="deviceName"
                  placeholder="e.g. Chennai-IN"
                  value={deviceData.deviceName}
                  onChange={handleDeviceDataChange}
                  error={deviceData.deviceNameStatus === "error"}
                  success={deviceData.deviceNameStatus === "success"}
                  disabled={togglePage.view === true}
                />
                {deviceData.deviceNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Device Name should be 1-50 characters (letters, numbers,
                      spaces, hyphens, underscores)
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              {/* Branch */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Branch <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="branch"
                  customStyles={{ optionPadding: 20 }}
                  value={deviceData.branch}
                  onChange={handleDeviceDataChange}
                  options={branchList.map((b) => ({
                    value: b.name,
                    label: b.name,
                  }))}
                  error={deviceData.branchStatus === "error"}
                  success={deviceData.branchStatus === "success"}
                  isClearable
                  isDisabled={togglePage.view === true}
                />
              </Grid>

              {/* Direction */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Direction <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="direction"
                  customStyles={{ optionPadding: 20 }}
                  value={deviceData.direction}
                  onChange={handleDeviceDataChange}
                  options={directionOptions}
                  error={deviceData.directionStatus === "error"}
                  success={deviceData.directionStatus === "success"}
                  isClearable
                  isDisabled={togglePage.view === true}
                />
              </Grid>

              {/* Cloud ID */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Cloud ID
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="cloudId"
                  placeholder="Boxtel Cloud ID"
                  value={deviceData.cloudId}
                  onChange={handleDeviceDataChange}
                  error={deviceData.cloudIdStatus === "error"}
                  success={deviceData.cloudIdStatus === "success"}
                  disabled={togglePage.view === true}
                />
              </Grid>

              {/* Notes */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Notes
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={3}
                  name="notes"
                  placeholder="Optional notes"
                  value={deviceData.notes}
                  onChange={handleDeviceDataChange}
                  error={deviceData.notesStatus === "error"}
                  success={deviceData.notesStatus === "success"}
                  disabled={togglePage.view === true}
                />
              </Grid>

              {/* Is Active (edit mode only) */}
              {(togglePage.edit || togglePage.view) && (
                <Grid size={{ xs: 12, sm: 4 }}>
                  <MaterialBox
                    lineHeight={0}
                    display="inline-block"
                    sx={{ mt: 2 }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          checked={deviceData.isActive}
                          onChange={handleActiveToggle}
                          disabled={togglePage.view === true}
                        />
                      }
                      label={
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Active
                        </MaterialTypography>
                      }
                    />
                  </MaterialBox>
                </Grid>
              )}
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.view ? (
            ""
          ) : togglePage.edit ? (
            <>
              {originalData.deviceName === deviceData.deviceName &&
              originalData.branch?.label === deviceData.branch?.label &&
              originalData.direction?.label === deviceData.direction?.label &&
              originalData.cloudId === deviceData.cloudId &&
              originalData.notes === deviceData.notes &&
              originalData.isActive === deviceData.isActive ? null : (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleBackDevice}
                >
                  Discard
                </MaterialButton>
              )}
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleAddDevice}
                disabled={!checkAllFields()}
              >
                Update
              </MaterialButton>
            </>
          ) : (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddDevice}
            >
              Submit
            </MaterialButton>
          )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default AddDevice;
